/* global FWP */

'use strict';

const $ = window.jQuery;

module.exports = function () {
    if ( $('.facetwp-template').length <= 0 ) {
        return
    }

    const $loader = $('.facetwp-loader')

    $(document).on('facetwp-loaded', function() {
        $loader.removeClass('is-visible')

        if ( $('.has-transition').length <= 0 ) {
            return
        }

        gsap.timeline().staggerFromTo(
            '.has-transition',
            .5,
            { scale: 0 },
            { scale: 1 },
            .3,
            { ease: "expo.inOut" }
        )
     });

    $(document).on('facetwp-refresh', function() {
        $loader.addClass('is-visible')
     });

    $('[data-reset="true"]').on('click', function() {
        FWP.reset()
        $('.facetwp-type-dropdown').find('select').val(null).trigger('change')
    })
}
